import { useState } from "react"
import { errorToast } from "@/v2-ui/toast"
import Editor from "@/v2-backoffice-client/components/editor"
import { useTenantUpdateMutation } from "@/v2-backoffice-client/tenant/update/tenant.update.mutation"

export type TenantUpdateConfigurationProps = {
  tenantId: number
  configuration: unknown
}

function TenantUpdateConfiguration(props: TenantUpdateConfigurationProps) {
  const { tenantId, configuration } = props

  const [error, setError] = useState<Error | undefined>()
  const [updateTenant, { loading }] = useTenantUpdateMutation({
    onError: setError,
  })

  errorToast(error, {
    title: "Failed to update team",
  })

  if (!tenantId) return null
  return (
    <Editor
      value={JSON.stringify(configuration, null, 2)}
      isSaving={loading}
      onSave={(value) => {
        let parsed = ""
        try {
          parsed = JSON.parse(value)
        } catch (error) {
          setError(error instanceof Error ? error : new Error(String(error)))
        }
        updateTenant({
          variables: {
            input: { Id: tenantId, Configuration: parsed },
          },
        })
      }}
    />
  )
}

export default TenantUpdateConfiguration
